import { useQuery } from '@tanstack/react-query';

import { apiService } from '@/services/api-service';
import type { PermissionMatrix } from '@/utils/permission-matrix';

/**
 * The permission model, fetched from the worker (#500).
 *
 * Fetched rather than imported: `buildPermissionMatrix` calls `hasPermission`, which lives in
 * `api/` beside D1 queries and Response builders, and bundling that into the app would ship
 * server code to every device. Fetching also makes the screen show what the DEPLOYED worker
 * enforces rather than what the installed bundle was built from — the two diverge whenever a
 * client is a version behind.
 *
 * Derived from code, not data, so it only changes on deploy: cached for the session.
 */
export function usePermissionMatrix() {
	return useQuery({
		queryKey: ['permissions', 'matrix'],
		queryFn: async () => {
			const res = await apiService.fetchApi('/permissions/matrix') as { data: PermissionMatrix };
			return res.data;
		},
		staleTime: 30 * 60 * 1000,
		gcTime: 60 * 60 * 1000,
	});
}
